<template>
    <v-container>
        <div class="d-flex" style="margin-bottom: 20px; margin-top: 10px">
            <div class="text-h3">Устройства</div>
            <v-spacer />
            <v-btn @click.stop="add">
                <v-icon>mdi-plus</v-icon>
                Устройство
            </v-btn>
        </div>

        <DeviceEditor v-show="editingDevice" v-model="editingDevice" @finish="editFinished" />

        <DeviceBrowser
            ref="browser"
            :filters="{}"
            @edit="e => loadAndEdit(e.id)"
        />
    </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import {Inject, Prop} from 'vue-property-decorator'
import Api from '@/services/Api'
import {createDevice, DeviceDraft} from '@/models/Device'
import DeviceBrowser from '@/components/browsers/DeviceBrowser.vue'
import DeviceEditor from '@/components/modals/DeviceEditor.vue'

@Component({
    components: {DeviceEditor, DeviceBrowser},
})
export default class DevicesView extends Vue
{
    @Inject('api') private api!: Api

    @Prop({type: Boolean, default: false})
    isCreating!: boolean

    editingDevice: DeviceDraft | null = null

    async created() {
        if (this.isCreating) {
            this.add()
        } else {
            const id = parseInt(this.$route.params.id)
            if (id) {
                await this.loadAndEdit(id)
            }
        }
    }

    async fetchOne(id: number) {
        return await this.api.getDevice(id)
    }

    async loadAndEdit(id: number) {
        const device = await this.fetchOne(id)
        this.edit(device)
    }

    add() {
        this.edit(createDevice())
    }

    edit(device: DeviceDraft) {
        this.editingDevice = device
        this.$router.push(device.id != null ? '/devices/edit/' + device.id : '/devices/create').catch(() => true)
    }

    editFinished() {
        this.editingDevice = null
        const browser = this.$refs.browser as DeviceBrowser
        browser.refresh()
        this.$router.push('/devices')
    }
}
</script>
